import { useMemo } from 'react'

import { deriveProductCapabilities } from '../utils/deriveProductCapabilities.js'

/**
 * React hook wrapper — memoizes `deriveProductCapabilities` over context parameters.
 *
 * @param {object|null} projectConfig - Configuration object from panel-config.json
 * @param {object|null} panelSettings - Configuration object from panel-settings.json
 * @param {object|null} product - Active product object
 * @param {string|null} productCategory - Business category identifier
 * @param {object[]} [allProducts=[]] - Full catalog products for global capability checks
 * @param {Record<string, unknown[]>} [interiorsData={}] - Global interiors assets by camera name
 * @returns {ReturnType<typeof deriveProductCapabilities>} Memoized product capabilities object
 */
export function useProductCapabilities(
  projectConfig,
  panelSettings,
  product,
  productCategory,
  allProducts = [],
  interiorsData = {},
) {
  return useMemo(
    () => deriveProductCapabilities({
      projectConfig,
      panelSettings,
      product,
      productCategory,
      allProducts,
      interiorsData,
    }), 
    [projectConfig, panelSettings, product, productCategory, allProducts, interiorsData])
}
